import { AbstractSearchCriteria } from './abstract-search-criteria';
import { KeyControlAndAbstractSearchCriteria } from './key-control-and-abstract-search-criteria';

export class DistributionChannelSearchCriteria extends KeyControlAndAbstractSearchCriteria {
    code: string = '';
    name: string = '';
    kcCompany: string = '';
}
